/* 狀態邏輯
1. 上架開關為關閉皆為 未上架
2. 活動開始時間以前為 即將開始
2-1. 超過(含)活動開始時間 為 活動截止
3. 上架時間 < 當前時間 < 活動開始時間 為 報名中
3-1. 若報名中時 報名人數 >= 報名人數上限為 已額滿
3-2. 若報名中時 名額上限 - 報名人數 <= 20為 即將額滿
 */
import styles from './style/EventStatusBadge.module.scss';

const EventStatusBadge = ({ theme, text }) => {
  const themeClass = styles[theme] || styles.default;

  return <span className={`${styles.badge} ${themeClass}`}>{text}</span>;
};

export default EventStatusBadge;
